import * as React from 'react';
import { IPeopleCards } from '../../interfaces/umbracoNodes/contentSlices';
import { ContentContainer } from '../base/contentContainer/contentContainer';
import { Column, Columns } from '../base/grid';
import {
	CardContent,
	CardWrapper,
	FirstNameWrapper,
	LastNameWrapper,
	RichTextStyled,
	Root,
	StyledButton,
	Image,
	RichTextTitleStyled,
} from './peopleCards.style';

type Props = {
	content: IPeopleCards;
};

export const PeopleCards = ({ content }: Props) => {
	return (
		<Root>
			<ContentContainer>
				{content.Values.Title && <RichTextTitleStyled content={content.Values.Title} type="h3" />}
				<Columns>
					{content.Values.Cards.map((peopleCard, index) => (
						<Column key={index} desktopSmall={1 / 4}>
							<CardWrapper>
								<Image src={peopleCard.Values.Image.Src} alt={peopleCard.Values.Image.Name} />
								<CardContent>
									{peopleCard.Values.Firstname && (
										<FirstNameWrapper>{peopleCard.Values.Firstname}</FirstNameWrapper>
									)}
									{peopleCard.Values.Lastname && (
										<LastNameWrapper>{peopleCard.Values.Lastname}</LastNameWrapper>
									)}
									{peopleCard.Values.Text && <RichTextStyled content={peopleCard.Values.Text} />}
									{peopleCard.Values.Link && (
										<StyledButton
											title={peopleCard.Values.Link.Name}
											type="secondary"
											href={peopleCard.Values.Link.Url}
											target={peopleCard.Values.Link.Target}
										/>
									)}
								</CardContent>
							</CardWrapper>
						</Column>
					))}
				</Columns>
			</ContentContainer>
		</Root>
	);
};
